// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2brCQ","filesListContainer":"PosDisputesFiles_filesListContainer__2uXIu","filesButton":"PosDisputesFiles_filesButton__3Ult8"};